function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * 
 * @file Helper for the box Tasks API
 * @author Box
 */
import TasksBase from './TasksBase';
import { ERROR_CODE_CREATE_TASK, ERROR_CODE_UPDATE_TASK, ERROR_CODE_DELETE_TASK, ERROR_CODE_FETCH_TASKS, API_PAGE_LIMIT } from '../../constants';

class TasksNew extends TasksBase {
  getUrlForFileTasks(id) {
    return "".concat(this.getBaseApiUrl(), "/undoc/files/").concat(id, "/linked_tasks?limit=").concat(API_PAGE_LIMIT);
  }

  getUrlForTaskCreateWithDeps() {
    return "".concat(this.getBaseApiUrl(), "/undoc/tasks/with_dependencies");
  }

  getUrlForTask(id) {
    return "".concat(this.getBaseApiUrl(), "/undoc/tasks/").concat(id);
  }

  getUrlForTaskWithDeps(id) {
    return "".concat(this.getBaseApiUrl(), "/undoc/tasks/").concat(id, "/with_dependencies");
  }

  updateTaskWithDeps(_ref) {
    let {
      errorCallback,
      file,
      successCallback,
      task
    } = _ref;
    this.errorCode = ERROR_CODE_UPDATE_TASK;
    const createTaskCollabsPayload = task.addedAssignees.map(assignee => {
      return {
        op: assignee.item && assignee.item.type === 'group' ? 'add_task_collaborators_expand_group' : 'add_task_collaborator',
        payload: {
          target: {
            type: assignee.item && assignee.item.type === 'group' ? 'group' : 'user',
            id: assignee.id
          }
        }
      };
    });
    const deleteTaskCollabsPayload = task.removedAssignees.map(assignee => {
      return {
        op: 'delete_task_collaborator',
        id: assignee.id
      };
    });

    const {
      id,
      addedAssignees,
      removedAssignees
    } = task,
          updateTaskPayload = _objectWithoutProperties(task, ["id", "addedAssignees", "removedAssignees"]);

    this.put({
      id: file.id,
      url: this.getUrlForTaskWithDeps(task.id),
      data: {
        data: [{
          op: 'update_task',
          payload: _objectSpread({}, updateTaskPayload)
        }, ...createTaskCollabsPayload, ...deleteTaskCollabsPayload]
      },
      successCallback,
      errorCallback
    });
  }

  deleteTask(_ref2) {
    let {
      errorCallback,
      file,
      successCallback,
      task
    } = _ref2;
    this.errorCode = ERROR_CODE_DELETE_TASK;
    this.delete({
      id: file.id,
      url: this.getUrlForTask(task.id),
      successCallback,
      errorCallback
    });
  }

  getTasksForFile(_ref3) {
    let {
      errorCallback,
      file,
      successCallback
    } = _ref3;
    this.errorCode = ERROR_CODE_FETCH_TASKS;
    this.get({
      id: file.id,
      url: this.getUrlForFileTasks(file.id),
      successCallback,
      errorCallback
    });
  }

  getTask(_ref4) {
    let {
      errorCallback,
      file,
      id,
      successCallback
    } = _ref4;
    this.errorCode = ERROR_CODE_FETCH_TASKS;
    this.get({
      id: file.id,
      url: this.getUrlForTask(id),
      successCallback,
      errorCallback
    });
  }

  createTaskWithDeps(_ref5) {
    let {
      errorCallback,
      file,
      successCallback,
      task,
      assignees
    } = _ref5;
    this.errorCode = ERROR_CODE_CREATE_TASK;
    const createTaskCollabsPayload = assignees.map(assignee => {
      return {
        target: {
          type: assignee.item && assignee.item.type === 'group' ? 'group' : 'user',
          id: assignee.id
        }
      };
    });
    const createTaskLinksPayload = [{
      target: {
        id: file.id,
        type: 'file'
      }
    }];
    const createTaskWithDepsPayload = {
      task: _objectSpread({}, task),
      assigned_to: createTaskCollabsPayload,
      task_links: createTaskLinksPayload
    };
    this.post({
      id: file.id,
      url: this.getUrlForTaskCreateWithDeps(),
      data: {
        data: _objectSpread({}, createTaskWithDepsPayload)
      },
      successCallback,
      errorCallback
    });
  }

}

export default TasksNew;
//# sourceMappingURL=TasksNew.js.map